import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";
import axios from "axios";
import * as ActionType from "./language.type";

// 1. Get All Languages
export const getAllLanguages = (payload) => (dispatch) => {
  apiInstanceFetch
    .get(
      `language/searchLanguages?start=${payload?.start || 1}&limit=${payload?.limit || 10}${payload?.search ? `&search=${payload?.search}` : ""}`
    )
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.GET_ALL_LANGUAGES,
          payload: { data: res.data, total: res.total },
        });
      }
    })
    .catch((error) => console.error(error));
};

// 2. Create Language
export const createLanguage = (payload) => (dispatch) => {
  axios
    .post("language/spawnLanguage", payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.CREATE_LANGUAGE, payload: res.data.data });
        setToast("success", res.data.message || "Language created successfully");
      } else {
        setToast("error", res.data.message || "Failed to create language");
      }
    })
    .catch((error) => {
      console.error(error);
      setToast("error", "Internal Server Error");
    });
};

// 4. Update Language
export const updateLanguage = (payload) => (dispatch) => {
  axios
    .patch("language/modifyLanguage", payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.UPDATE_LANGUAGE, payload: res.data.data });
        setToast("success", res.data.message || "Language updated successfully");
      } else {
        setToast("error", res.data.message || "Failed to update language");
      }
    })
    .catch((error) => {
      console.error(error);
      setToast("error", "Internal Server Error");
    });
};

// 5. Toggle isActive / isDefault
export const toggleLanguage = (payload) => (dispatch) => {
  apiInstanceFetch
    .patch(
      `language/toggleSwitchState?languageCode=${payload.languageCode}&toggleType=${payload.toggleType}`
    )
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.TOGGLE_LANGUAGE,
          payload: { ...res, languageCode: payload.languageCode, toggleType: payload.toggleType },
        });
        setToast("success", res.message || "Status updated successfully");
      } else {
        setToast("error", res.message || "Something went wrong");
      }
    })
    .catch((error) => {
      console.error(error);
      setToast("error", "Internal Server Error");
    });
};

// 6. Delete Language
export const deleteLanguage = (languageCode) => (dispatch) => {
  apiInstanceFetch
    .delete(`language/removeLanguage?languageCode=${languageCode}`)
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.DELETE_LANGUAGE, payload: languageCode });
        setToast("success", res.message || "Language deleted successfully");
      } else {
        setToast("error", res.message || "Something went wrong");
      }
    })
    .catch((error) => {
      console.error(error);
      setToast("error", "Internal Server Error");
    });
};

// 7. Upload Translations via CSV
export const uploadTranslations = (formData) => (dispatch) => {
  return axios.post(`translation/fillTranslations`, formData)
  .then((res) => {
    if (res.data.status) {
      setToast("success", res.data.message);
      return res.data;
    } else {
      setToast("error", res.data.message || "Something went wrong");
      return res.data;
    }
  })
  .catch((error) => {
    console.error(error);
    setToast("error", "Failed to upload translations");
    throw error;
  });
};

// 8. Download Translations CSV
export const downloadTranslationsCSV = () => (dispatch) => {
  return axios.get(`translation/extractTranslationsCSV`, {
    responseType: "blob",
  });
};

// 9. Update Translation Key-Value
export const updateLanguageTranslations = (payload) => (dispatch) => {
  apiInstanceFetch
    .patch("translation/modifyTranslations", payload)
    .then((res) => {
      if (res.status) {
        setToast("success", res.message || "Translation updated successfully");
        dispatch(getAllLanguages());
      } else {
        setToast("error", res.message || "Failed to update translation");
      }
    })
    .catch((error) => {
      console.error(error);
      setToast("error", "Internal Server Error");
    });
};

// 10. Get Translations for a Language
export const getLanguageTranslations = (payload) => (dispatch) => {
  const { languageCode, module, search } = payload;

  dispatch({ type: ActionType.GET_LANGUAGE_TRANSLATIONS, payload: { doc: null, loading: true } });

  let url = `translation/searchLanguageTranslations?languageCode=${languageCode}`;
  if (module) url += `&module=${module}`;
  if (search) url += `&search=${search}`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.GET_LANGUAGE_TRANSLATIONS, payload: res });
      }
    })
    .catch((error) => {
      console.error(error);
      dispatch({ type: ActionType.GET_LANGUAGE_TRANSLATIONS, payload: { doc: null, loading: false } });
    });
};

// Backward compatibility or extra options
export const getLanguageOptions = (search) => (dispatch) => {
  apiInstanceFetch
    .get(`language/searchLanguages?search=${search || ""}`)
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.GET_LANGUAGE_OPTIONS, payload: res.data });
      }
    })
    .catch((error) => console.error(error));
};
